import { JERSEY_OVERVIEW } from '@/constants';
export const getDefaultState = () => {
  return {
    items: [],
    loading: false,
    more: true,
    numbers: [],
    page: 0,
    pageLoaded: [],
    selectedFrame: null,
    total: 0,
    track: null,
    view: JERSEY_OVERVIEW,
    visible: false,
  }
};

export default {
  filtersList: {
    sortDirection: [
      {
        label: 'Asc',
        value: 'asc'
      },
      {
        label: 'Desc',
        value: 'desc',
      }
    ],
  },
  options: {
    limit: 90,
    sort_by: 'frame_id',
    sort_direction: 'asc',
  },
  ...getDefaultState(),
};

